/* "Find Your Fit" size guide modal for the product detail page.

   The modal is a native <dialog> (#sizeguidemodal) rendered on product pages by
   snippets/flyout-panels.liquid. showModal() handles the backdrop, focus
   trapping, Escape to close and returning focus to the trigger; this adds the
   open trigger, the close button, closing on a backdrop click, and holding the
   page still behind it.

   Without JS the trigger keeps its href and navigates to the fitting guide. */
(function () {
  'use strict';

  var TOGGLE = '.js-pdpSizeFinderToggle';
  var LOCK_CLASS = 'sizeGuideModal-open';

  function modal() {
    return document.getElementById('sizeguidemodal');
  }

  function open() {
    var dialog = modal();
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return false;
    dialog.showModal();
    document.documentElement.classList.add(LOCK_CLASS);
    return true;
  }

  function close() {
    var dialog = modal();
    if (dialog && dialog.open) dialog.close();
  }

  /* 'close' fires however the dialog shuts — the X, a backdrop click, Escape —
     so the scroll lock is released in one place. It doesn't bubble, so listen
     in the capture phase. */
  document.addEventListener('close', function (e) {
    if (e.target === modal()) document.documentElement.classList.remove(LOCK_CLASS);
  }, true);

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;

    if (e.target.closest(TOGGLE)) {
      // No modal on this page (or no <dialog> support) — let the href do the work
      if (open()) e.preventDefault();
      return;
    }

    if (e.target.closest('.js-sizeGuideModalClose')) {
      close();
      return;
    }

    /* A click on the ::backdrop is reported on the <dialog> itself; the
       dialog's content fills its box, so anything outside that box is backdrop. */
    var dialog = modal();
    if (dialog && e.target === dialog) {
      var box = dialog.getBoundingClientRect();
      var inside = e.clientX >= box.left && e.clientX <= box.right &&
        e.clientY >= box.top && e.clientY <= box.bottom;
      if (!inside) close();
    }
  });

  /* Size guide (snippets/size-guide.liquid): the Triumph / sloggi tabs each
     own a category dropdown, and every <option> value names the chart
     ([data-chart]) it shows. Liquid sets which tab and chart start open. */
  function showChart(guide, chartId) {
    var measured = false;
    clearHighlight();
    guide.querySelectorAll('.js-sizeGuideChart').forEach(function (chart) {
      chart.hidden = chart.dataset.chart !== chartId;
      if (!chart.hidden && chart.hasAttribute('data-measured')) measured = true;
    });

    // The cm / in switch only means something on charts with body measurements
    var units = guide.querySelector('.js-sizeGuideUnits');
    if (units) units.hidden = !measured;
  }

  /* cm / in switch. Measurement cells are written in cm ("68-72"); the cm text
     is kept in data-cm the first time a cell is converted, so switching back
     restores the original rather than rounding twice. The choice is remembered
     per browser — storage can be blocked, so it's best-effort. */
  var UNIT_KEY = 'sizeGuideUnit';
  var CM_PER_IN = 2.54;

  function toInches(cmText) {
    return cmText.split('-').map(function (part) {
      var cm = parseFloat(part);
      return isNaN(cm) ? part : (cm / CM_PER_IN).toFixed(1);
    }).join('-');
  }

  function setUnit(guide, unit) {
    if (unit !== 'in') unit = 'cm';

    guide.querySelectorAll('.js-sizeGuideUnit').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.unit === unit ? 'true' : 'false');
    });
    guide.querySelectorAll('.js-sizeGuideUnitLabel').forEach(function (label) {
      label.textContent = '(' + unit + ')';
    });

    guide.querySelectorAll('.sizeGuide__table').forEach(function (table) {
      var head = table.tHead && table.tHead.rows[0];
      if (!head) return;
      var cols = [];
      Array.prototype.forEach.call(head.cells, function (th, i) {
        if (th.hasAttribute('data-measure')) cols.push(i);
      });
      if (!cols.length) return;

      Array.prototype.forEach.call(table.tBodies[0].rows, function (row) {
        cols.forEach(function (i) {
          var cell = row.cells[i];
          if (!cell) return;
          if (!cell.dataset.cm) cell.dataset.cm = cell.textContent.trim();
          cell.textContent = unit === 'in' ? toInches(cell.dataset.cm) : cell.dataset.cm;
        });
      });
    });
  }

  function storedUnit() {
    try {
      return window.localStorage.getItem(UNIT_KEY);
    } catch (err) {
      return null;
    }
  }

  document.querySelectorAll('.js-sizeGuide').forEach(function (guide) {
    if (storedUnit() === 'in') setUnit(guide, 'in');
  });

  /* Row + column highlight under the pointer, like a printed chart you run a
     finger along. A body cell lights its row and column; a header cell just its
     column. pointerover also fires on tap, so it works on touch too. No table
     here uses colspan, so cellIndex is the column. */
  var ROW_HOVER = 'is-rowHover';
  var COL_HOVER = 'is-colHover';
  var hoverCell = null;

  function clearHighlight() {
    if (!hoverCell) return;
    var table = hoverCell.closest('table');
    if (table) {
      table.querySelectorAll('.' + ROW_HOVER + ', .' + COL_HOVER).forEach(function (el) {
        el.classList.remove(ROW_HOVER, COL_HOVER);
      });
    }
    hoverCell = null;
  }

  function highlight(cell) {
    if (cell === hoverCell) return;
    clearHighlight();
    hoverCell = cell;

    var col = cell.cellIndex;
    Array.prototype.forEach.call(cell.closest('table').rows, function (row) {
      if (row.cells[col]) row.cells[col].classList.add(COL_HOVER);
    });
    if (cell.tagName === 'TD') cell.parentElement.classList.add(ROW_HOVER);
  }

  document.addEventListener('pointerover', function (e) {
    var cell = e.target instanceof Element && e.target.closest('.sizeGuide__table td, .sizeGuide__table th');
    if (cell) {
      highlight(cell);
    } else {
      clearHighlight();
    }
  });

  function selectBrand(tab) {
    var guide = tab.closest('.js-sizeGuide');
    if (!guide) return;

    guide.querySelectorAll('.js-sizeGuideBrand').forEach(function (t) {
      var active = t === tab;
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.tabIndex = active ? 0 : -1;

      var brandPanel = document.getElementById(t.getAttribute('aria-controls'));
      if (brandPanel) brandPanel.hidden = !active;
    });

    var activePanel = document.getElementById(tab.getAttribute('aria-controls'));
    var select = activePanel && activePanel.querySelector('.js-sizeGuideCategory');
    if (select) showChart(guide, select.value);
  }

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var tab = e.target.closest('.js-sizeGuideBrand');
    if (tab) {
      selectBrand(tab);
      return;
    }

    var unitBtn = e.target.closest('.js-sizeGuideUnit');
    var guide = unitBtn && unitBtn.closest('.js-sizeGuide');
    if (guide) {
      setUnit(guide, unitBtn.dataset.unit);
      try {
        window.localStorage.setItem(UNIT_KEY, unitBtn.dataset.unit);
      } catch (err) {
        // Storage blocked — the switch still works for this page view
      }
    }
  });

  document.addEventListener('change', function (e) {
    if (!(e.target instanceof Element) || !e.target.matches('.js-sizeGuideCategory')) return;
    var guide = e.target.closest('.js-sizeGuide');
    if (guide) showChart(guide, e.target.value);
  });

  // Arrow keys move between the brand tabs, as a tablist should
  document.addEventListener('keydown', function (e) {
    if (!(e.target instanceof Element) || !e.target.matches('.js-sizeGuideBrand')) return;
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;

    var tabs = Array.prototype.slice.call(
      e.target.closest('[role="tablist"]').querySelectorAll('.js-sizeGuideBrand')
    );
    var step = e.key === 'ArrowRight' ? 1 : -1;
    var next = tabs[(tabs.indexOf(e.target) + step + tabs.length) % tabs.length];
    e.preventDefault();
    next.focus();
    selectBrand(next);
  });
})();
